import styles from './Modal.module.scss'

export const Modal = ({open, handleClose, children})=> {
    if (!open) {
        return null;
      }
    return <div className={styles.background}>
        <div className={styles.modal}>
        <span className={styles.close} onClick={handleClose}>
            +
          </span>
            {children}
        </div>
    </div>
}